module.exports = __webpack_public_path__ + "media/fonts/TTCommons-DemiBold-f798f9613d383fa25191894122de1235.woff2";